// extracted by mini-css-extract-plugin
export default {"cards":"List_cards__2u9nG","wrapper":"List_wrapper__yjJpZ"};